import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Admin } from '../../api.js';
import { useAuth } from '../../AuthContext.jsx';
import { PageHeader } from '../../components/PageHeader.jsx';

export default function Dashboard() {
  const { can } = useAuth();
  const [stats, setStats] = useState({});

  useEffect(() => {
    Promise.all([
      can('joinRequests', 'read')
        ? Admin.joinRequests.list('new').catch(() => ({ joinRequests: [] }))
        : Promise.resolve({ joinRequests: null }),
      can('contactMessages', 'read')
        ? Admin.contactMessages.list('new').catch(() => ({ messages: [] }))
        : Promise.resolve({ messages: null }),
      can('bookings', 'read')
        ? Admin.bookings.list('pending').catch(() => ({ bookings: [] }))
        : Promise.resolve({ bookings: null }),
      can('players', 'read')
        ? Admin.players.list().catch(() => ({ players: [] }))
        : Promise.resolve({ players: null }),
    ]).then(([jr, cm, bk, pl]) => {
      setStats({
        newJoins: jr.joinRequests?.length,
        newMessages: cm.messages?.length,
        pendingBookings: bk.bookings?.length,
        players: pl.players?.length,
      });
    });
  }, [can]);

  const cells = [
    { label: 'New join requests', value: stats.newJoins, to: '/admin/join-requests', accent: stats.newJoins > 0 },
    { label: 'New inquiries', value: stats.newMessages, to: '/admin/contact-messages', accent: stats.newMessages > 0 },
    { label: 'Pending bookings', value: stats.pendingBookings, to: '/admin/bookings', accent: stats.pendingBookings > 0 },
    { label: 'Active players', value: stats.players, to: '/admin/players' },
  ];

  return (
    <div>
      <PageHeader eyebrow="Overview" title="Admin." description="Start here. Jump to whatever needs attention." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cells.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            className={`card hover:border-ink/30 transition-colors group ${
              c.accent ? 'border-brand/30 bg-brand/[0.04]' : ''
            }`}
          >
            <div className="eyebrow mb-4">{c.label}</div>
            <div className="numeric text-6xl text-ink leading-none">{c.value ?? '—'}</div>
            <div className="mt-6 flex items-center justify-between text-xs text-ink-3 group-hover:text-ink transition-colors">
              <span>Open</span>
              <span>→</span>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-10 grid md:grid-cols-2 gap-4">
        <Link to="/admin/events" className="card hover:border-ink/30 transition-colors">
          <div className="eyebrow mb-2">Schedule</div>
          <div className="font-display text-2xl">Add a match or practice</div>
          <p className="text-sm text-ink-2 mt-2">Publish fixtures to the public calendar.</p>
        </Link>
        <Link to="/admin/campaigns" className="card hover:border-ink/30 transition-colors">
          <div className="eyebrow mb-2">Email</div>
          <div className="font-display text-2xl">Send an update</div>
          <p className="text-sm text-ink-2 mt-2">Club news or fundraiser to opted-in members.</p>
        </Link>
      </div>
    </div>
  );
}
